import React from "react";
import { NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel2";
import "react-owl-carousel2/src/owl.carousel.css";

import "./Slider.modules.scss";

const Slider = ({ items }) => {
  const getItems = items.map(( element, index) => (
    <React.Fragment>
      {console.log(element)}
      {element.link ? (
        <NavLink to={element.link}>
          <img src={element.image} />
        </NavLink>
      ) : (
        <img src={element.link} />
      )}
    </React.Fragment>
  ));

  const carouselOptions = {
    items: 3,
    nav: true,
    rewind: true,
    autoplay: true,
    navText: ["<", ">"],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      992: {
        items: 4,
      },
    },
  };

  return (
    <div className="slider">
      <div className="container">
        <div className="row">
          <OwlCarousel options={carouselOptions}>{getItems}</OwlCarousel>
        </div>
      </div>
    </div>
  );
};

export default Slider;
